import { Component, Input } from '@angular/core';
import { Award } from '@app/definitions/interfaces';

@Component({
    selector: 'app-standart-card-award',
    templateUrl: './standart_card_award.component.html',
    styleUrls: ['./standart_card_award.component.scss']
})
export class StandartCardAwardComponent {
    @Input() award: Award;

    constructor() {}
}
